import {
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Box,
  InputAdornment,
} from "@mui/material";
import { CmpInputField } from "../ToolBox/ToolBox";
import CloseIcon from "@mui/icons-material/Close";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { fcheck_null_undefine_replace_empty } from "../../../Utility/Utilitys";
import {   common_SupplierSearchgetrow } from "../../../Server/ApiV2";
import { CmpTextFieldV1, CmpTextFieldV2 } from "../ToolBox/ToolBoxV1";
import { DataGridPro } from "@mui/x-data-grid-pro";
import SearchIcon from "@mui/icons-material/Search"; 

const GCSupplierSearch = ({
  xValue = "",
  xType = "text",
  xReadOnly = false,
  xOnChange = () => {},
  xName = "barcode",
  xListValue,
  basketValue = [],
  onApply = () => {},
  title = "Modal",
}) => {
  const [sopenModal, setopenModal] = useState(false);
  const [searchText, setSearchText] = useState(xValue);
  const [selectedIds, setSelectedIds] = useState([]);
  const [basketRows, setBasketRows] = useState([]);
  const [selectedBasketIds, setSelectedBasketIds] = useState([]);
  // Sample data in your provided format
  const [rows, setRows] = useState([]);

  const columns = [
    { field: "AcCd", headerName: "Code", width: 100 },
    { field: "Name1", headerName: "Name", width: 200 }, 
  ];

  const basketColumns = [
    { field: "AcCd", headerName: "Code", width: 150 },
    { field: "Name1", headerName: "Name", width: 350 },
  ];

  // const handleTransfer = () => {
  //   const newItems = rows.filter((row) => selectedIds.includes(row.UID));
  //   const uniqueNewItems = newItems.filter(
  //     (item) => !basketRows.some((br) => br.UID === item.UID)
  //   );
  //   setBasketRows([...basketRows, ...uniqueNewItems]);
  // };
    //  If You Want to  Replace
  // const handleTransfer = () => {
  //   const selectedItems = rows.filter((row) => selectedIds.includes(row.UID));
  //   setBasketRows(selectedItems); // Reset and replace basket with selected only
  //   setSelectedBasketIds(selectedItems.map(item => item.UID)); // auto-select in basket
  // };

  //  If You Want to Append Instead of Replace
  const handleTransfer = () => {
    const selectedItems = rows.filter((row) => selectedIds.includes(row.AcCd));
  
    const uniqueNewItems = selectedItems.filter(
      (item) => !basketRows.some((br) => br.AcCd === item.AcCd)
    );
  
    const updatedBasket = [...basketRows, ...uniqueNewItems];
    const updatedSelected = [
      ...selectedBasketIds,
      ...uniqueNewItems.map(item => item.AcCd),
    ];
  
    setBasketRows(updatedBasket);
    setSelectedBasketIds(updatedSelected);
  };

  const handleApplyToSearch = () => { 
    const selectedObjects = basketRows.filter((row) =>
      selectedBasketIds.includes(row.AcCd)
    );
    onApply(selectedObjects);
    setopenModal(false);
  };

  const fOnLoad = async (v_AnyData = "") => {
    const payload = {
      v_AnyData: v_AnyData,
      v_Cd: "",
      v_Name: "",
      v_Prnt: "C",
    };
    let resp = await common_SupplierSearchgetrow(
      fcheck_null_undefine_replace_empty(payload)
    );

    if (resp?.status === 200) {
      console.log(resp);
      let respData =
        resp?.data?.ResultSet?.length == 0
          ? []
          : resp?.data?.ResultSet.map((obj, i) => ({
              ...obj,
              id: i + 1,
            }));
      setRows(respData);
    } else {
      setRows([]);
    }
  };
  const openModal = (xValue) => {
    setSearchText(xValue);
    setopenModal(true);
    fOnLoad(xValue).then(() => {
      setBasketRows(basketValue);
      setSelectedBasketIds(basketValue.map((x) => x.AcCd));
    });
  };
  return (
    <>
      <Grid container spacing={0}>
        <Grid item xs={5} md={3}>
          <div className="d-flex">
            <CmpInputField
              xref={""}
              xValue={xValue}
              xType={xType}
              xName={xName}
              xReadOnly={xReadOnly}
              xOnChange={xOnChange}
              xOnKeyUp={(e) => {
                if (e.key === "Enter") {
                  openModal(xValue);
                }
              }}
              xError={false}
              xErrorMessage={""}
            />
            <Button
              onClick={() => {
                openModal(xValue);
              }}
              variant="outlined"
              disabled={xReadOnly}
              sx={{
                minWidth: "40px",
                paddingTop: "0px !important",
                paddingBottom: "0px !important",
              }}
            >
              <MoreHorizIcon fontSize="small" />
            </Button>
          </div>
        </Grid>
        <Grid item xs={7} md={9}>
          <CmpInputField
            xref={""}
            xValue={xListValue}
            xType={xType}
            xName={xName}
            xReadOnly={true}
            xError={false}
            xErrorMessage={""}
          />
        </Grid>
      </Grid>

      <Dialog
        open={sopenModal}
        onClose={() => setopenModal(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle
        sx={{
          backgroundColor: '#1976d2',      // Primary blue background
          color: '#fff',                   // White text
          fontWeight: 'bold',              // Emphasized title
          fontSize: '1.1rem',              // Slightly larger text
          padding: '2px 15px',            // Comfortable spacing
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          position: 'relative',
          
        }}
        >
          {title}
          <IconButton
            aria-label="close"
            onClick={() => setopenModal(false)}
            sx={{
              // position: "absolute",
              // right: 8,
              // top: 8,
              // color: (theme) => theme.palette.grey[500],
              color: '#ffffff',             // White icon color
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <Grid container spacing={0.5} >
            <Grid item  xs={12} md={3} marginY={1}>
              {/* <h6 style={{ color: "blue" }}>Any Data</h6> */}
              <CmpTextFieldV2
              xLabelText="Any Data"
                xref={""}
                xValue={searchText}
                xType="text"
                xName="searchText"
              
                xOnChange={(e) => {
                  setSearchText(e.target.value);
                }}
                xOnKeyUp={(e) => {
                  if (e.key === "Enter") {
                    fOnLoad(searchText);
                  }
                }}
                xError={false}
                xErrorMessage={""}
                xLabel="Any Data"
                xInputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => fOnLoad(searchText)} size="small">
                        <SearchIcon sx={{ color: "gray" }} />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
          </Grid>

          <Grid
            container
            spacing={0}
          
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12} md={5.5}> 
              <DataGridPro
                sx={{ height: 400, border: 1,
                  borderColor: "primary.light",
                  '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: '#1976d2', // ← your desired color (blue)
                  color: '#fff',
                  fontWeight: 'bold',
                } ,
                // "& .MuiDataGrid-columnHeaderTitle": {
                //   whiteSpace: "normal",
                //   wordWrap: "break-word",
                //   fontSize: "11px", // Optional for better fit
                // },
              }} // Fixed height of 300px
                checkboxSelection
                hideFooter={true}
                experimentalFeatures={{ columnGrouping: true }}
                columnGroupingModel={[
                  {
                    groupId: 'Search Grid',
                    headerAlign: 'center',
                    children: [
                      { field: "AcCd", },
                      { field: "Name1", }, 
                    ],
                  }]}
                rows={rows}
                columns={columns}
                getRowId={(row) => row.AcCd}
                onSelectionModelChange={(ids) => setSelectedIds(ids)}
                rowHeight={30}
                headerHeight={40}
                // hideFooter={rows.length < 10}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                // autoHeight
              />
            </Grid>

            <Grid item xs={12} md={1} textAlign={'center'}>
              <Button
                onClick={handleTransfer}
                variant="contained"
                size="small"
                
              >
                <ArrowForwardIcon />
              </Button>
            </Grid>

            <Grid item xs={12} md={5.5}> 
              <DataGridPro
                sx={{ height: 400, border: 1,
                  borderColor: "primary.light",'& .MuiDataGrid-columnHeaders': {
                  backgroundColor: '#1976d2', // ← your desired color (blue)
                  color: '#fff',
                  fontWeight: 'bold',
                } }} // Fixed height of 300px
                checkboxSelection
                hideFooter={true}
                experimentalFeatures={{ columnGrouping: true }}
                columnGroupingModel={[
                  {
                    groupId: 'Search Basket',
                    headerAlign: 'center',
                    children: [
                      { field: "AcCd", },
                      { field: "Name1", }, 
                    ],
                  }]}
                rows={basketRows}
                columns={basketColumns}
                getRowId={(row) => row.AcCd}
                rowHeight={30}
                headerHeight={40}
                // hideFooter={basketRows.length < 10}
                // autoHeight
                selectionModel={selectedBasketIds}
                onSelectionModelChange={(ids) => setSelectedBasketIds(ids)}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
        <Grid container spacing={1} justifyContent={'center'}>
        <Grid item xs={12} md={2} textAlign={'center'}>  <Button
            variant="outlined"
            color="primary"
            onClick={() => setBasketRows([])}
            size="small"
            fullWidth
          >
            Clear Basket
          </Button></Grid>
        <Grid item xs={12} md={2} textAlign={'center'}> <Button
            variant="contained"
            color="primary"
            onClick={handleApplyToSearch}
            size="small"
            fullWidth
          >
            Apply  
          </Button></Grid>
        </Grid>
        
         
        </DialogActions>
      </Dialog>
    </>
  );
};

export default GCSupplierSearch;
